var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 17.5,
    cy: 17.428,
    rx: 17.5,
    ry: 17.428
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.835 0 0 7.803 0 17.428c0 7.388 4.61 13.699 11.12 16.238-.16-1.377-.289-3.5.057-5.006.317-1.363 2.045-8.664 2.045-8.664s-.518-1.047-.518-2.582c0-2.424 1.411-4.232 3.168-4.232 1.498 0 2.219 1.12 2.219 2.453 0 1.492-.951 3.73-1.455 5.81-.418 1.735.878 3.155 2.592 3.155 3.112 0 5.502-3.27 5.502-7.975 0-4.174-3.01-7.086-7.316-7.086-4.984 0-7.908 3.715-7.908 7.56 0 1.491.576 3.098 1.296 3.973.145.172.159.33.116.502-.13.545-.432 1.735-.49 1.98-.072.315-.26.387-.59.229-2.19-1.019-3.558-4.189-3.558-6.756 0-5.494 4.004-10.543 11.566-10.543 6.063 0 10.788 4.303 10.788 10.07 0 6.01-3.803 10.844-9.074 10.844-1.772 0-3.443-.918-4.004-2.009l-1.095 4.146c-.389 1.52-1.455 3.414-2.175 4.576 1.642.502 3.37.774 5.185.774 9.665 0 17.5-7.803 17.5-17.428C35 7.803 27.165 0 17.5 0z",
    fill: "#E60019"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.5fbf1033f037b3f529cb8c1217ae179b.svg";
export { ForwardRef as ReactComponent };